export default "__VITE_ASSET__5248726f__"